
import { B2BDealType, B2CDealType, CostDealType } from "@/app/constants";
import { IPricing } from "@/app/domain";

import { CalculationStrategy, PriceResult } from "../base/calculation.strategy";
import { ReactiveComponent } from "../../entities/base-component";

export class TotalDueCalculationStrategy extends CalculationStrategy {
    calculate(component: ReactiveComponent, [taxSum, subtotal]): PriceResult {
        if (!subtotal) {
            return this.getDefaultResult();
        }

        return {
            price: this.calculateTotalDue(
                taxSum, subtotal,
                CostDealType,
            ),
            priceB2C: this.calculateTotalDue(
                taxSum, subtotal,
                B2CDealType,
            ),
            priceB2B: this.calculateTotalDue(
                taxSum, subtotal,
                B2BDealType,
            ),
        };
    }

    private calculateTotalDue(
        taxSum: number,
        subtotal: IPricing,
        dealType: string,
    ) {
        return taxSum + subtotal.getSystemPrice(dealType).getValue();
    }
}
